import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledContentWrapper = styled.div`
  padding: ${({ theme }) =>
    `${utils.rem(theme.Spacing.Size.XSmall)} ${utils.rem(
      theme.Spacing.Size.MediumSmall
    )} ${utils.rem(theme.Spacing.Size.MediumSmall)} ${utils.rem(theme.Spacing.Size.MediumSmall)}`};

  ${({ theme }) => css`
    @media (min-width: ${theme.Screen.Size.XSmall}px) {
      padding: ${utils.rem(theme.Spacing.Size.MediumSmall)} ${utils.rem(theme.Spacing.Size.Small)}
        ${utils.rem(theme.Spacing.Size.Small)} ${utils.rem(theme.Spacing.Size.Small)};
    }
  `};
`;

export const StyledDiv = styled.div`
  margin-bottom: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
`;

export const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${({ theme }) => css`
    @media (min-width: ${theme.Screen.Size.XSmall}px) {
      min-width: ${utils.rem(460)};
      display: block;
    }
  `};
`;
